import { db } from '@/lib/firebase';
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  Timestamp,
  arrayUnion
} from 'firebase/firestore';

export interface Trip {
  id: string;
  date: Date;
  location: string;
  capacity: number;
  registered: number;
  status: 'open' | 'full' | 'closed';
  duration: string;
  activities: string[];
  price: number;
  included: string[];
  registeredUsers: string[];
}

const tripsCollection = collection(db, 'trips');

export async function getTrips(): Promise<Trip[]> {
  const snapshot = await getDocs(tripsCollection);
  return snapshot.docs.map(docSnap => {
    const data = docSnap.data();
    return {
      id: docSnap.id,
      ...data,
      date: (data.date?.toDate ? data.date.toDate() : new Date(data.date)),
      activities: data.activities || [],
      included: data.included || [],
      registeredUsers: data.registeredUsers || [],
    } as Trip;
  });
}

export async function addTrip(trip: Omit<Trip, 'id'>) {
  await addDoc(tripsCollection, {
    ...trip,
    date: Timestamp.fromDate(new Date(trip.date)),
  });
}

export async function updateTrip(id: string, data: Partial<Trip>) {
  const tripRef = doc(db, 'trips', id);
  if (data.date) {
    data.date = Timestamp.fromDate(new Date(data.date));
  }
  await updateDoc(tripRef, data);
}

export async function deleteTrip(id: string) {
  const tripRef = doc(db, 'trips', id);
  await deleteDoc(tripRef);
}

export async function registerForTrip(tripId: string, userId: string) {
  const tripRef = doc(db, 'trips', tripId);
  await updateDoc(tripRef, {
    registeredUsers: arrayUnion(userId)
  });
} 